import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { trendCategories, trendingTopics } from '@/mocks/home';

export default function TrendingSection() {
  const [category, setCategory] = useState('全部');

  const list =
    category === '全部' ? trendingTopics : trendingTopics.filter((t) => t.category === category);

  return (
    <section id="trending" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          index="06"
          kicker="TRENDING NOW"
          title="热门吃瓜：这几件事最近问的人最多"
          desc="按分类挑你想补的事件。进度条代表这条时间线的整理完成度，越满说明背景、反转和后续越齐全。"
        />

        <div className="mt-8 inline-flex flex-wrap gap-1 rounded-lg border border-background-200 bg-background-100/70 p-1">
          {trendCategories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCategory(c)}
              aria-pressed={category === c}
              className={`whitespace-nowrap rounded-full px-4 py-2 font-label text-sm transition-colors cursor-pointer ${
                category === c
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:bg-background-50 hover:text-foreground-900'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {list.map((topic, i) => (
            <Reveal key={topic.title} delay={(i % 4) * 70}>
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-100/50 p-5 transition-colors hover:border-primary-300 hover:bg-background-50">
                <div className="flex items-center justify-between gap-2">
                  <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] font-medium text-secondary-900">
                    {topic.category}
                  </span>
                  <span className="inline-flex items-center gap-1 font-label text-[11px] text-primary-600">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-fire-fill" />
                    </span>
                    {topic.heat}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-base font-bold leading-snug text-foreground-950">
                  {topic.title}
                </h3>
                <p className="mt-2 flex-1 font-body text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {topic.summary}
                </p>

                <div className="mt-4 flex flex-wrap gap-1.5">
                  {topic.tags.map((t) => (
                    <span
                      key={t}
                      className="inline-flex items-center rounded-full bg-accent-100 px-2 py-0.5 font-label text-[10px] font-medium text-accent-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <div className="mt-5 border-t border-background-200 pt-4">
                  <div className="flex items-center justify-between font-label text-[11px] text-foreground-500">
                    <span>补课进度</span>
                    <span className="font-semibold text-foreground-800">{topic.progress}%</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-300">
                    <div
                      className="h-full rounded-full bg-primary-500 transition-all duration-700"
                      style={{ width: `${topic.progress}%` }}
                    />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 py-12 text-center font-body text-sm text-foreground-500">
            这个分类下暂时还没有整理中的事件，换个分类看看。
          </p>
        )}
      </div>
    </section>
  );
}